/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';

export default function ShowRTIG(props)
{
    const [showRTIG, setShowRTIG] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setShowRTIG(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleShowRTIG = () => {
        setShowRTIG(!showRTIG);
        props.onChange(!showRTIG)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={showRTIG}
                        onChange={handleShowRTIG}
                        name="Show RTIG"
                        color="primary"
                        />
                    }
                    label="Show Real Time Interaction Guidance"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Show the Real Time Interaction Guidance widget">
                        <AddToQueueIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

